import React from 'react'
import {
  MicrowaveIcon,
  OvenIcon,
  WaterBathIcon,
} from '@lojinha/design-system/src/icons'
import { t } from '../../../dictionary'

export const PREPARATION_METHODS = {
  MICROWAVE: 'MICROWAVE',
  WATER_BATH: 'WATER_BATH',
  OVEN: 'OVEN',
} as const

export const VIDEOS_ID = {
  HOME_MADE: '1E3WcQKrV3g',
  MICROWAVE: 'xD0iT_Ankno',
  WATER_BATH: '-sjedAJAcDw',
  OVEN: 'rbYGvAxQFas',
} as const

export const CONTENTS = {
  [PREPARATION_METHODS.MICROWAVE]: {
    title: t.preparingMethods.microwave.title,
    steps: [
      t.preparingMethods.microwave.step1,
      t.preparingMethods.microwave.step2,
      t.preparingMethods.microwave.step3,
      t.preparingMethods.microwave.step4,
    ],
    icon: <MicrowaveIcon size="x3" />,
    videoId: VIDEOS_ID.MICROWAVE,
  },
  [PREPARATION_METHODS.WATER_BATH]: {
    title: t.preparingMethods.waterBath.title,
    steps: [
      t.preparingMethods.waterBath.step1,
      t.preparingMethods.waterBath.step2,
      t.preparingMethods.waterBath.step3,
      t.preparingMethods.waterBath.step4,
      t.preparingMethods.waterBath.step5,
    ],
    icon: <WaterBathIcon size="x3" />,
    videoId: VIDEOS_ID.WATER_BATH,
  },
  [PREPARATION_METHODS.OVEN]: {
    title: t.preparingMethods.oven.title,
    steps: [
      t.preparingMethods.oven.step1,
      t.preparingMethods.oven.step2,
      t.preparingMethods.oven.step3,
      t.preparingMethods.oven.step4,
      t.preparingMethods.oven.step5,
    ],
    icon: <OvenIcon size="x3" />,
    videoId: VIDEOS_ID.OVEN,
  },
}
